import Vue from 'vue';
import Router from 'vue-router';
import Start from '@/components/Start';
import DateTime from '@/components/DateTime';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/:datetime?/:color?/:title?',
            name: 'Index',
            component: DateTime
        },
        {
            path: '/old/:year?/:month?/:day?/:hour?/:minute?/:second?',
            name: 'Params',
            component: Start
        },
        {
            path: '/to/:datetime?/:color?/:title?',
            name: 'DateTime',
            component: DateTime
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js